














import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class IconPillButton extends Vue {
  @Prop({ type: String, default: "button" }) as!: string;
  @Prop({ type: String, default: undefined }) to!: string | undefined;
  @Prop({ type: Number, default: 0 }) count!: number;

  get componentTag() {
    return this.as === "router-link" ? "router-link" : "button";
  }

  get componentProps() {
    const attrs: any = { ...(this.$attrs || {}) };

    if (this.componentTag === "router-link") {
      return { ...attrs, to: this.to };
    }

    if (attrs.type === undefined) attrs.type = "button";
    return attrs;
  }
}
